import { List, ListItemButton, ListItemText, ListProps } from '@mui/material'
import { Device, GeoCoordinate } from '../types'
import { useTranslation } from 'react-i18next'

interface DeviceDetailsListProps extends Omit<ListProps, 'children'> {
  device: Device
}

export default function DeviceDetailsList({ device, ...props }: DeviceDetailsListProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The current location of the device.
   */
  const currentLocation: GeoCoordinate | null = device?.locationHistory?.[0]
    ? {
        lat: parseFloat(device.locationHistory[0].lat.toString()),
        long: parseFloat(device.locationHistory[0].lng.toString())
      }
    : null

  return (
    <List {...props}>
      {device?.asset?.name && device.asset.name !== device.name && (
        <ListItemButton>
          <ListItemText primary={device.asset.name} secondary={t('name')} />
        </ListItemButton>
      )}

      <ListItemButton key="device-code">
        <ListItemText primary={device.name} secondary={t('deviceCode')} />
      </ListItemButton>

      <ListItemButton key="short-uuid">
        <ListItemText primary={device.shortUUID} secondary={t('shortUUID')} />
      </ListItemButton>

      {currentLocation && (
        <ListItemButton key="current-location">
          <ListItemText
            primary={`${currentLocation.lat}, ${currentLocation.long}`}
            secondary={t('currentLocation')}
          />
        </ListItemButton>
      )}

      {device?.asset?.project && (
        <ListItemButton key="project">
          <ListItemText primary={device.asset.project.name} secondary={t('project')} />
        </ListItemButton>
      )}

      {device?.asset?.company && (
        <ListItemButton key="company">
          <ListItemText primary={device.asset.company.name} secondary={t('owner')} />
        </ListItemButton>
      )}
    </List>
  )
}
